// 截取两位数
export function filterTwoName (val) {
  let userName
  if (val.length > 2) {
    userName = val.substr(-2)
  } else {
    userName = val
  }
  return userName
}

// 岗位配置 人员配置
export function filterWorkType (value) {
  let str = Number(value)
  if (str === 0) {
    return '月休四天'
  }
  if (str === 1) {
    return '其他'
  }
  if (str === 2) {
    return '三包一'
  }
  if (str === 3) {
    return '二包一'
  }
  if (str === 4) {
    return '工作日上班'
  }
  if (str === 5) {
    return '上一休一'
  }
  if (str === 6) {
    return '周日休息'
  }
  if (str === 7) {
    return '上二休一'
  }
  if (str === 8) {
    return '上三休一'
  }
  if (str === 9) {
    return '上六休一'
  }
  if (str === 10) {
    return '月休15天'
  }
  if (str === 11) {
    return '周六周日上班'
  }
  if (str === 12) {
    return '四包一'
  }
}
